import { render, staticRenderFns } from "./goodDistributionList.vue?vue&type=template&id=4ae4985e&"
import script from "./goodDistributionList.vue?vue&type=script&lang=js&"
export * from "./goodDistributionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports